<template>
  <div
    v-if="newNoticeInfo && newNoticeInfo.title"
    v-show="show"
    class="full-tips"
  >
    <div
      class="message-box clearfix"
    >
      <i
        slot="icon"
        class="iconfont iconNotice"
      />

      <div
        ref="wrap"
        class="wrap"
      >
        <div
          ref="marquee"
          :style="pos"
          class="marquee clearfix"
        >
          <div
            ref="text"
            class="text"
          >
            <span :style="{color: newNoticeInfo.style || '#666'}">{{ newNoticeInfo.title }}</span>
          </div>
        </div>
      </div>
      <a
        v-if="newNoticeInfo.link"
        ref="detailBtn"
        :href="newNoticeInfo.link"
        target="_blank"
        class="btn"
      >{{ $t('message["89"]') }}</a>
      <a
        class="iconfont iconicon-test5 close-btn fr"
        @click="handleClose"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data () {
    return {
      show: true,
      textsWidth: 0,
      distance: 0,
      timer: null
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('newFeature', ['newNoticeInfo']),
    annoce () {
      const { announce2 } = this.baseinfo || {}
      return announce2
    },
    pos () {
      return {
        width: this.textsWidth * 2 + 'px',
        transform: `translate3d(${-this.distance}px, 0, 0)`,
        transition: `all 0s`
      }
    }
  },
  async mounted () {
    if (this.annoce) {
      let chain = await this.getNewNoticeInfo({ type: 2 })
      chain.onSuccess(res => {
        this.$nextTick(() => {
          this.zMarquee(30)
        })
      })
    }
  },
  methods: {
    ...mapActions('newFeature', ['getNewNoticeInfo', 'closeNewAnnounce']),
    zMarquee (speedParam) {
      let self = this
      let parent = this.$refs.wrap
      let child = this.$refs.marquee
      let $detailBtn = this.$refs.detailBtn
      let speed = speedParam || 40 // 跑马灯速度

      this.timer = null
      this.distance = 1

      // 图标宽20，查看详情宽60，关闭按钮宽56
      if (this.newNoticeInfo.link) {
        parent.style.width = 1280 - 20 - $detailBtn.offsetWidth - 56 + 'px'
      } else {
        parent.style.width = 1280 - 20 - 56 + 'px'
      }

      if (parent.offsetWidth >= child.scrollWidth) {
        parent.style.width = child.scrollWidth - 30 + 'px'
        this.textsWidth = child.scrollWidth
        return
      }

      child.innerHTML += child.innerHTML
      this.textsWidth = child.scrollWidth + 2 // 跑马灯内容

      self.timer = setInterval(() => {
        if (self.distance >= self.textsWidth) {
          self.distance = 0
        }
        self.distance++
      }, speed)
    },
    async handleClose () {
      this.show = false
      const { annid } = this.newNoticeInfo || {}
      await this.closeNewAnnounce({
        annid
      })
    }
  }
}
</script>

<style scoped lang="scss">
.full-tips {
  height: 40px;
  font-size: 0px;
  text-align: center;
  background: rgba(76, 160, 242, 0.15);
}

.message-box {
  width: 1280px;
  margin: 0 auto;

  .iconfont {
    display: inline-block;
  }
  .iconNotice {
    margin-right: 4px;
    padding: 12px 0;
    color: #51a2ef;
    font-size: 16px;
  }
  .btn{
    position: relative;
    top: -1px;
    margin-left: 8px;
    font-size: 14px;
    padding: 10px 0;
  }
  .close-btn {
    margin-left: 24px;
    margin-right: 8px;
    padding: 13px 0;
    font-size: 14px;
  }
}
.wrap {
  position: relative;
  top: 4px;
  display: inline-block;
  padding: 0 1px;
  width: 1160px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  overflow: hidden;
  .marquee {
    width: 999999px;
    height: 100%;
  }
  .text {
    float: left;
    padding-right: 30px;
    white-space: nowrap;
    font-size: 14px;
    transform: translate3d(0,0,0);
    backface-visibility: hidden;
    perspective: 1000;
  }
}
</style>
